import type { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

interface ActionsEmptyProps {
  daysBack?: number;
}

export const ActionsEmpty: FunctionComponent<ActionsEmptyProps> = ({
  daysBack,
}) => (
  <p className="empty-list">
    {daysBack && (
      <FormattedMessage
        id="templates.actions_empty.no-actions-in-the-last-daysback-days"
        defaultMessage="No actions in the last {daysBack} days"
        description="The message to display when no actions are found in the last X days, where X is a dynamic value."
        values={{
          daysBack,
        }}
      />
    )}
    {!daysBack && (
      <FormattedMessage
        id="templates.actions_empty.no-actions"
        defaultMessage="No actions"
        description="The message to display when there are no actions."
      />
    )}
  </p>
);
